
import {AdminPromotion} from './admin-promotion.model';

export class PromotionList {
    pageCount: number;
    rowCount: number;
    dataList: AdminPromotion[] = [];
}
